import { Typography, type TypographyProps } from "~/common/mui";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { DateFormatType, formatDate } from "~/common/utils/DateFormatter";
import { showDateAsCalendarWeek } from "~/utils/features";

type ReplenishmentDateProps = Omit<TypographyProps, "children"> & {
  date: Date | null;
};

export const ReplenishmentDate = ({ date, ...props }: ReplenishmentDateProps) => {
  const { t } = useTranslation();

  let dateString;
  if (date) {
    if (showDateAsCalendarWeek()) {
      const months = Math.ceil(dayjs(date).diff(dayjs(), "month", true));
      dateString = t("common.month", { count: months });
    } else {
      dateString = formatDate(date, DateFormatType.DATE);
    }
  } else {
    dateString = "-";
  }

  return (
    <Typography fontWeight="normal" {...props}>
      {t("addProduct.replenishment", { date: "" })}
      <b>{dateString}</b>
    </Typography>
  );
};
